import { GetDetailResponse, GetListResponse } from "@app/types";
import { CreateTransferPayload, RankingResponse, TransferHistory } from "@app/types/affiliate.type";
import HttpService from "@core/services/http/http.service";
import { RequestParams, Signal } from "@core/services/http/http.type";

class _AffiliateService {
  public postAffiliate(affiliateId: string) {
    return HttpService.post<
      GetDetailResponse<{ message: string; isVoucher: boolean }>
    >("/user/api/v2/affiliates", {
      body: { affiliateId },
    });
  }

  public validateAffiliate(affiliateId: string) {
    return HttpService.post("/user/api/v3/affiliates/validate", {
      body: { affiliateId },
    });
  }

  public getRanking() {
    return HttpService.get<GetDetailResponse<RankingResponse>>("/user/api/v3/affiliates/ranking");
  }

  public createTransfer(payload: CreateTransferPayload) {
    return HttpService.post("/user/api/v3/affiliates/request-transfer", {
      body: { ...payload },
    });
  }

  public getHistory(requestParams: RequestParams, signal?: Signal) {
    return HttpService.get<GetListResponse<TransferHistory>>("/user/api/v3/affiliates/transfer-history", {
      queryParams: {...requestParams},
      signal,
    });
  }
}

const AffiliateService = new _AffiliateService();

export default AffiliateService;
